import { render, staticRenderFns } from "./BigBasket.vue?vue&type=template&id=bfad7b54&scoped=true&"
import script from "./BigBasket.vue?vue&type=script&lang=js&"
export * from "./BigBasket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfad7b54",
  null
  
)

export default component.exports